// InventoryAdminInventory - Metric Card Component
import React from 'react';
import '../../../../assests/css/admin/Analytics/MetricCard/MetricCard.css';

const MetricCard = ({ icon, label, value, change, changeType, iconColor }) => {
  return (
    <div className="InventoryAdminInventory-metric-card">
      <div className="InventoryAdminInventory-metric-header">
        <div className={`InventoryAdminInventory-metric-icon ${iconColor}`}>
          {icon}
        </div>
        <div className="InventoryAdminInventory-metric-label">{label}</div>
      </div>
      <div className="InventoryAdminInventory-metric-value">{value}</div>
      <div className={`InventoryAdminInventory-metric-change ${changeType}`}>
        <span className="InventoryAdminInventory-metric-change-icon">
          {changeType === 'positive' ? '↑' : '↓'}
        </span>
        <span>{change}</span>
      </div>
    </div>
  );
};

export default MetricCard;